import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';
const token = localStorage.getItem('authToken');
const MatrimonyRequestList = () => {
    const [categories, setCategories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState({ address: "", pincode: "" });
    const [showModal, setShowModal] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [updatedStatus, setUpdatedStatus] = useState("");

    const history = useHistory();

    const getData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/contactrequestsmatrimony`, {
                params: {
                    page: currentPage,

                },
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setCategories(response.data?.data);
            setTotalPages(response.data.data?.totalPages);
        } catch (error) {
            console.log(error);
        }
    };

    const handleStatusUpdate = async (id, status) => {
        try {
            const response = await axios.put(
                `https://samaj.aasmo.in/api/admin/contactrequestsmatrimony/${id}`,
                { status },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response) {
                console.log("Status Updated Successfully");
                setEditMode(false);
                getData();
            }
        } catch (error) {
            console.log(error);
        }
    };


      const handleDelete = async (id) => {
        try {
          const response = await axios.delete(`https://samaj.aasmo.in/api/admin/contactrequestsmatrimony/${id}`,{
            headers: {
              Authorization: `Bearer ${token}`, 
          }
          });
          if (response) {
            console.log("Deleted Successfully");
            getData();
          }
        } catch (error) {
          console.log(error);
        }
        setShowModal(false);
      };

      const handleDeleteClick = (id) => {
        setSelectedCategoryId(id);
        setShowModal(true);
    };

    useEffect(() => {
        getData();
    }, [currentPage, searchQuery]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (e) => {
        setSearchQuery({
            ...searchQuery,
            [e.target.name]: e.target.value
        });
    };

    const handleDownload = () => {
        const fields = [
            "id",
            "matrimonyUser.fullName",
            "requester.fullName",
            "createdAt",
            "status"
        ];

        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(categories);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'matrimonyRequestedUser_list.csv');
    }


    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="col-lg-12">
            <div className="card">
                <div className="header">
                    <h2>Matrimony Request List</h2>
                </div>
                <div className="d-flex justify-content-start">
                    <div style={{ marginLeft: "20px" }}>
                        <button className="btn btn-primary " onClick={handleDownload}>Download CSV</button>
                    </div>

                </div>
                <div className="body table-responsive">
                    <table className="table table-hover">
                        <thead style={{ textAlign: "center" }}>
                            <tr>
                                <th>S.No</th>
                                <th>Matrimony User</th>
                                <th>Requester User</th>

                                <th>Date</th>
                                <th>Status</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                            {categories.map((category, index) => {
                                let statusClass;
                                switch (category.status) {
                                    case 'no':
                                        statusClass = 'text-danger';
                                        break;
                                    case 'yes':
                                    case 'approved':
                                        statusClass = 'text-success';
                                        break;
                                    default:
                                        statusClass = 'text-primary';
                                }
                                return (
                                    <tr key={category.id}>
                                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                                        <td>{category?.matrimonyUser?.fullName}</td>
                                        <td>{category?.requester?.fullName}</td>



                                        <td> {formatDate(category.createdAt)}</td>
                                        {editMode ? (
                                            <td>
                                                <select
                                                    className="form-control"
                                                    value={updatedStatus}
                                                    onChange={(e) => setUpdatedStatus(e.target.value)}
                                                >
                                                    <option value="no">Rejected</option>
                                                    <option value="yes">Approved</option>
                                                    <option value="pending">Pending</option>
                                                </select>
                                            </td>
                                        ) : (
                                            <td className={statusClass}>
                                                {category.status === "no"
                                                    ? "Rejected"
                                                    : category.status === "yes" || category.status === "approved"
                                                        ? "Approved"
                                                        : "Pending"}
                                            </td>
                                        )}
                                        <td>
                                            {editMode ? (
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleStatusUpdate(category._id, updatedStatus)}
                                                >
                                                    Save
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => setEditMode(true)}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </td>
                                        <td> <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category._id)}></i>
                                           </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="body">
                    <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    Previous
                                </NavLink>
                            </li>
                            {[...Array(totalPages).keys()].map(page => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <NavLink
                                        to="#"
                                        className="page-link"
                                        onClick={() => handlePageChange(page + 1)}
                                    >
                                        {page + 1}
                                    </NavLink>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    Next
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <ConfirmDeleteModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={() => handleDelete(selectedCategoryId)}
            />
        </div>
    );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(MatrimonyRequestList);
